var app = globalThis;
globalThis.appCustomerSpace = globalThis.appCustomerSpace || {};

appCustomerSpace.ModalCustomItemsList = (function(superClass) {
  utils.extend(ModalCustomItemsList, superClass);

  function ModalCustomItemsList() {
    ModalCustomItemsList.__super__.constructor.apply(this, arguments);

    if(this.$html.find('.schedule-hours').length) {
      this.$html.find('.modal-dialog').removeClass('modal-sm').addClass('modal-lg');
    }
  }

  ModalCustomItemsList.prototype.init = function() {
    var modal = this;

    appCustomerSpace.creationForm.currentStep.initCKEditor(modal.$html);
    appCustomerSpace.creationForm.currentStep.initBusinessHour(modal.$html);
    appCustomerSpace.creationForm.initUploaders(modal.$html.find('.file-uploader'));
    appCustomerSpace.LimitlessPlugins.initPlugins(modal.$html);

    modal.$html.on('click', '.submit-modal', function(){
      modal.close();
      return false;
    })

    return ModalCustomItemsList.__super__.init.apply(this, arguments);
  };

  ModalCustomItemsList.prototype.callbackSuccess = function(data, successMsg) {
    return ModalCustomItemsList.__super__.callbackSuccess.call(this, data);
  };

  return ModalCustomItemsList;

})(appCustomerSpace.ModalCreationFormSubmissionFunnel);
